helpers = (function () {
  function getSymbolPos(reel, row) {
    const symbolReel = resourceManager.get('slotContainer:reelContainer:reel' + reel);
    const symPos = {
      x: symbolReel.x,
      y: symbolReel.y + row * gameData.symbolHeight,
    };
    const containerPos = resourceManager.get('slotContainer').position;
    const containerScaleX = resourceManager.get('slotContainer').scale.x;
    const containerScaleY = resourceManager.get('slotContainer').scale.y;

    let pos = {
      x: symPos.x * containerScaleX + containerPos.x,
      y: symPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  function getNudgeSymbolPos(reel) {
    const symbolReel = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + reel);
    const symPos = {
      x: symbolReel.x,
      y: symbolReel.y + gameData.symbolHeight,
    };
    const containerPos = resourceManager.get('nudgeSlotContainer').position;
    const containerScaleX = resourceManager.get('nudgeSlotContainer').scale.x;
    const containerScaleY = resourceManager.get('nudgeSlotContainer').scale.y;

    let pos = {
      x: symPos.x * containerScaleX + containerPos.x,
      y: symPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  function getWildPanelSymbolPos(index) {
    const wildPanel = resourceManager.get(
      'freeSpinsWildPanel:freeSpinsWildPanelContainer:wildsContainer:symbol' + index
    );
    const panelPos = {
      x: wildPanel.x,
      y: wildPanel.y,
    };
    const containerPos = resourceManager.get('freeSpinsWildPanel:freeSpinsWildPanelContainer').position;
    const containerScaleX = resourceManager.get('freeSpinsWildPanel:freeSpinsWildPanelContainer').scale.x;
    const containerScaleY = resourceManager.get('freeSpinsWildPanel:freeSpinsWildPanelContainer').scale.y;

    let pos = {
      x: panelPos.x * containerScaleX + containerPos.x,
      y: panelPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  return {
    getSymbolPos: getSymbolPos,
    getNudgeSymbolPos: getNudgeSymbolPos,
    getWildPanelSymbolPos: getWildPanelSymbolPos,
  };
})();
